import { tokens } from '@news-mono/design-tokens'
import React from 'react'

const { neutral, utility } = tokens.thenightly.colors.palette

export interface IconEditTN {
    className?: string
    hasError?: boolean
}

export const IconEditTN: React.FC<IconEditTN> = ({ className, hasError }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        className={className}
    >
        <path
            d="M1.87604 17.1156C1.92198 16.7021 1.94496 16.4954 2.00751 16.3022C2.06301 16.1307 2.14143 15.9676 2.24064 15.8171C2.35246 15.6475 2.49955 15.5005 2.79373 15.2063L16 2C17.1046 0.895427 18.8955 0.895428 20 2C21.1046 3.10457 21.1046 4.89543 20 6L6.79373 19.2063C6.49955 19.5005 6.35245 19.6475 6.18289 19.7594C6.03245 19.8586 5.86929 19.937 5.69785 19.9925C5.5046 20.055 5.29786 20.078 4.88437 20.124L1.5 20.5L1.87604 17.1156Z"
            stroke={hasError ? utility.error.default : neutral[70]}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
IconEditTN.displayName = 'IconEditTN'
